module.exports = "<p>\n  device-list works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/device-list/device-list.component.html
// module id = ./src/app/device-list/device-list.component.html
// module chunks = main